import { useCallback } from 'react'

import { useMutateResetExpenseRequest } from '../../models/useMutateResetExpenseRequest'

interface UseResetExpenseRequestPresenterParams {
  onReset: () => void
}

export const useResetExpenseRequestPresenter = ({
  onReset,
}: UseResetExpenseRequestPresenterParams) => {
  const { mutate, isLoading } = useMutateResetExpenseRequest()

  const resetForm = useCallback(async () => {
    try {
      await mutate()
    } catch {
      // Silently handle — DELETE is best-effort server cleanup
    }
    onReset()
  }, [mutate, onReset])

  return {
    commands: { resetForm },
    states: { isLoading },
  }
}
